import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["localesLoaderMap"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { createScopedInstance, getLanguage } from './citrix-translate';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var createScopedInstanceAndLoader = function createScopedInstanceAndLoader(loaderInstanceOptions) {
  var localesLoaderMap = loaderInstanceOptions.localesLoaderMap,
    instanceOptions = _objectWithoutProperties(loaderInstanceOptions, _excluded);
  var scopedi18nInstance = createScopedInstance(instanceOptions);
  var loaded = false;
  var LocalizationLoader = function LocalizationLoader(_ref) {
    var children = _ref.children,
      _ref$loadingElement = _ref.loadingElement,
      loadingElement = _ref$loadingElement === void 0 ? null : _ref$loadingElement;
    var _React$useState = React.useState(!loaded),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];
    var addResourceBundle = scopedi18nInstance.addResourceBundle;
    React.useEffect(function () {
      if (loaded) {
        setLoading(false); // handle potential race condition with multiple loaders
        return;
      }
      var addLocaleFromLanguage = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _localesLoaderMap;
          var preferredLanguage, localeGetter, json;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                preferredLanguage = getLanguage();
                localeGetter = (_localesLoaderMap = localesLoaderMap[preferredLanguage]) !== null && _localesLoaderMap !== void 0 ? _localesLoaderMap : localesLoaderMap['en'];
                _context.next = 4;
                return localeGetter();
              case 4:
                json = _context.sent;
                addResourceBundle(preferredLanguage, instanceOptions.namespace, json, true, true);
                loaded = true;
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function addLocaleFromLanguage() {
          return _ref2.apply(this, arguments);
        };
      }();
      addLocaleFromLanguage().then(function () {
        setLoading(false);
      });
    }, [addResourceBundle]);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: loading ? loadingElement : children()
    });
  };
  return {
    LocalizationLoader: LocalizationLoader,
    t: scopedi18nInstance.t,
    scopedi18nInstance: scopedi18nInstance
  };
};